'use client'

import { Box, Flex, Text, IconButton, HStack, VStack, Image, Icon } from '@chakra-ui/react';
import { FiArrowLeft, FiCopy, FiStar, FiEdit2 } from 'react-icons/fi'
import { useTranslations } from 'next-intl'
import { toaster } from '@/components/ui/toaster'
import { getAvatarImage, getAvatarIndex } from '@/lib/utils/avatar.utils';
import TouchableOpacity from '../ui/TouchableOpacity';

interface TraderDetailHeaderProps {
  traderName: string
  traderAddress: string
}

export function TraderDetailHeader({
  traderName,
  traderAddress,
}: TraderDetailHeaderProps) {
  const t = useTranslations()

  const handleCopyAddress = async () => {
    try {
      await navigator.clipboard.writeText(traderAddress)
      toaster.create({
        title: t('common.copiedToClipboard') || 'Copied to clipboard!',
        description: abbreviateHashString(traderAddress),
        type: 'success',
        duration: 2000,
      })
    } catch {
      toaster.create({
        title: t('common.copyFailed') || 'Failed to copy address!',
        type: 'error',
        duration: 2000,
      })
    }
  }

  const abbreviateHashString = (hash: string, prefixLength = 6, suffixLength = 4) => {
    if (hash.length <= prefixLength + suffixLength) {
      return hash
    }
    return `${hash.slice(0, prefixLength)}...${hash.slice(-suffixLength)}`
  }

  return (
    <Flex
      height='44px'
      align='center'
    >
      <Flex w={'44px'} height={'full'} align={'center'} justify={'center'}>
        <Image
          src={getAvatarImage(getAvatarIndex(traderAddress || '')).src}
          width={6}
          height={6}
          rounded={'full'}
        />
      </Flex>
      {/* Center: Trader info */}
      <VStack gap={0} flex={1} justify="center" align="flex-start">
        <Text fontSize="sm" fontWeight="bold" color="white">
          {traderName}
        </Text>
        <HStack gap={4}>
          <Text lineHeight={1} fontSize="xs" color="gray.400">
            {abbreviateHashString(traderAddress)}
          </Text>
          <TouchableOpacity>
            <Icon
              size="xs"
              color="gray.400"
              onClick={handleCopyAddress}
            >
              <FiCopy />
            </Icon>
          </TouchableOpacity>
        </HStack>
      </VStack>
    </Flex>
  );
}